// P1.6 — offline resilience for core read screens (web). Caches the last
// successful payload in localStorage so Today / My Crops / Handbook / Season
// Plan keep rendering the grower's saved garden with no connection.
const PREFIX = 'hg_cache_';

export function cacheSet(key, data) {
  try { localStorage.setItem(PREFIX + key, JSON.stringify({ data, savedAt: Date.now() })); } catch { /* ignore */ }
}

export function clearCache() {
  try {
    Object.keys(localStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => localStorage.removeItem(k));
  } catch { /* ignore */ }
}

export function cacheGet(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && 'data' in parsed) return parsed;
  } catch { /* ignore */ }
  return null;
}

// axios: a network failure has no `response`; HTTP errors carry response.status.
// 401/403 mean logged-out, not offline — never serve a stale garden then.
export function isOfflineError(e) {
  const status = e?.response?.status;
  return status === undefined || status >= 500;
}

export async function loadWithCache(key, fetcher) {
  try {
    const data = await fetcher();
    cacheSet(key, data);
    return { data, offline: false, savedAt: null };
  } catch (e) {
    if (isOfflineError(e)) {
      const cached = cacheGet(key);
      if (cached) return { data: cached.data, offline: true, savedAt: cached.savedAt };
    }
    throw e;
  }
}

export function savedAgo(ts) {
  if (!ts) return '';
  const mins = Math.floor((Date.now() - ts) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr ago`;
  const days = Math.floor(hrs / 24);
  return days === 1 ? 'yesterday' : `${days} days ago`;
}
